export default __webpack_public_path__ + "static/media/cl_national_back.83d14bf2.png";